import { fileKindService } from 'services/fileService';
import { FileKindSnapshot } from 'services/fileService/fileKindService/types';
import { EXTENSIONS } from 'shared/constants/EXTENSIONS';

export const GALLERY_FILE_TYPE = {
  VIDEO: 'video',
  IMAGE: 'image',
  CONVERTED_PDF: 'convertedPdf',
  PDF: EXTENSIONS.PDF,
  WORD: 'word',
  EXCEL: 'excel',
  OTHER: 'other',
} as const;

export type GalleryFileType =
  (typeof GALLERY_FILE_TYPE)[keyof typeof GALLERY_FILE_TYPE];

export function classifyGalleryFileType(
  file: FileKindSnapshot
): GalleryFileType {
  if (fileKindService.isVideo(file)) {
    return GALLERY_FILE_TYPE.VIDEO;
  }

  if (fileKindService.isImage(file)) {
    return GALLERY_FILE_TYPE.IMAGE;
  }

  if (fileKindService.isConvertedPdf(file)) {
    return GALLERY_FILE_TYPE.CONVERTED_PDF;
  }

  if (fileKindService.isPdf(file)) {
    return GALLERY_FILE_TYPE.PDF;
  }

  if (fileKindService.isWord(file)) {
    return GALLERY_FILE_TYPE.WORD;
  }

  if (fileKindService.isExcel(file)) {
    return GALLERY_FILE_TYPE.EXCEL;
  }

  return GALLERY_FILE_TYPE.OTHER;
}

export type GalleryListRoute = 'video' | 'galleryImage' | 'generic';

export function resolveGalleryListRoute(
  file: FileKindSnapshot
): GalleryListRoute {
  if (fileKindService.isVideo(file)) {
    return 'video';
  }

  if (fileKindService.shouldShowAsImageInGallery(file)) {
    return 'galleryImage';
  }

  return 'generic';
}

export type MiniatureDocumentRoute =
  | 'word'
  | 'excel'
  | 'pdfThumbnail'
  | 'fallback';

export function resolveMiniatureDocumentRoute(
  file: FileKindSnapshot & { downloadSrc?: string }
): MiniatureDocumentRoute {
  if (fileKindService.isWord(file) && file.downloadSrc) {
    return 'word';
  }

  if (fileKindService.isExcel(file) && file.downloadSrc) {
    return 'excel';
  }

  if (fileKindService.resolvePdfThumbnailModel(file)) {
    return 'pdfThumbnail';
  }

  return 'fallback';
}
